import filter from 'lodash/filter';
import get from 'lodash/get';
import lowerFirst from 'lodash/lowerFirst';
import T from 'prop-types';
import React, { memo } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslations } from 'srcAlias/global/locale';

const PageTitle = memo(({ branding, pageName, path, segmentName }) => {
  const translations = useTranslations();
  let title = '';

  if (path) {
    title = get(translations, path, '');
  } else {
    const pageProps = `${segmentName}.${lowerFirst(pageName)}`;

    const prefix = get(
      translations,
      `${pageProps}.title`,
      get(
        translations,
        `${pageProps}.heading`,
        get(
          translations,
          `${segmentName}.title`,
          get(translations, `${segmentName}.heading`, '')
        )
      )
    );

    const suffix = get(
      branding,
      `${get(window, '__BRAND__', 'default')}.title`,
      ''
    );

    title = filter([prefix, suffix]).join(' - ');
  }

  return (
    <Helmet>
      <title>{title}</title>
    </Helmet>
  );
});

PageTitle.displayName = 'PageTitle';

PageTitle.propTypes = {
  branding: T.object,
  pageName: T.string,
  path: T.string,
  segmentName: T.string,
};

export default PageTitle;
